import { setCookie } from '@websrc/App/Helpers/cookieUtil'
import { mapCookiePolicy } from '@websrc/DataMappers/mapCookiePolicy'

export type CurrentSelection = ReturnType<typeof mapCookiePolicy>['preferences'][0] & {
  selected: boolean
}

export type SetCookieSettings = {
  type: 'necessary' | 'selection' | 'all'
  current: CurrentSelection[]
  setCallback: () => void
}

export const setCookieSettings = ({ type, current, setCallback }: SetCookieSettings) => {
  const handleCookieValue = (cookieOp: (typeof current)[0]) => {
    switch (type) {
      case 'all':
        return true
      case 'selection':
        return cookieOp.selected
      case 'necessary':
        return cookieOp.category === 'necessary' ? true : false
    }
  }

  setCookie({
    cookiePreferences: current.map((c) => ({
      key: c.category,
      value: handleCookieValue(c),
    })),
  })

  setCallback()
}
